export class JWTAuthRequest {
  username: string;
  password: string;
}

export class JwtAuthResponse {
  jwttoken: string;
  loggedUserType: string;

  loggedUserIdentity: {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
  };

}



// WEBPACK FOOTER //
// ./src/model/Credential.ts